/**
 * Converts a java-serialized unix timestamp to long date format
 * Example: 1513194947000 => 12/13/17 12:55:47 pm
 *
 * @param  {String} value the timestamp to convert
 * @return {String}
 */
import moment from 'moment';
import _ from 'lodash';

export default function longDate(value) {
  if (!value || !_.isNumber(value)) {
    return '';
  }
  var date = new Date(value);
  return moment(date).format('MM/DD/YY [at] h:mm a');
}
